'use client';

import * as React from 'react';

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

import { useMonkeysComponentAttributes } from '../../provider/context';
import { cn } from '../base/utils';
import { getOverlaySurfaceClassName } from './internal/overlaySurface';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardPortal = HoverCardPrimitive.Portal;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => {
  const componentAttributes = useMonkeysComponentAttributes();
  return (
    <HoverCardPrimitive.Content
      {...componentAttributes}
      {...props}
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      data-monkeys-component="hover-card"
      data-slot="content"
      data-surface="menu"
      className={cn(
        'z-50 w-64 origin-[--radix-hover-card-content-transform-origin] border p-4 outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        getOverlaySurfaceClassName('menu'),
        className,
      )}
    />
  );
});
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardContent, HoverCardPortal, HoverCardTrigger };
